<d-internal-hold-view *ngIf="viewStateService.view === 'internal-hold-view'"></d-internal-hold-view>
<d-internal-video-view *ngIf="viewStateService.view === 'internal-video-view'"></d-internal-video-view>
<d-client-view *ngIf="viewStateService.view === 'client-view'"></d-client-view>
